import { useTranslation } from "react-i18next";
import { BasePanel } from "~/components/base-panel";
import { Codes } from "./codes";

export const DatabaseCodes = () => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <BasePanel title={t("thema.tabs.database")} className="h-full">
      <Codes variant="database" />
    </BasePanel>
  );
};
